//#region types
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { InternationalPaymentFormStepProps } from "models/propTypes/incomingInvoicePropTypes";
import { SelectInputProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { GroupSection, SelectInput, TextInput, VerticalFormField } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { CountryHelper, LocalizationHelperInstance } from "utils/helpers";

const InternationalPaymentFormStep: React.FC<InternationalPaymentFormStepProps<IncomingInvoiceFormTypes.Todo>> = ({
  connect,
  invoice,
  bicRequired,
}) => {
  return (
    <Grid container className={cssExports.sectionedForm} marginBottom={2} marginTop={2}>
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("iban")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.IBAN)}
        noOuterSpacing
      />
      {bicRequired &&
        (invoice.supplier?.bIC ? (
          <VerticalFormField<TextInputProps>
            Component={TextInput}
            {...connect("bic")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.BicOrSwift)}
          />
        ) : (
          <>
            <Grid item className={cssExports.textBlack} marginBottom={1} marginTop={1}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.bicFieldLabel)}
            </Grid>
            <VerticalFormField<TextInputProps>
              Component={TextInput}
              {...connect("bic")}
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.BicOrSwift)}
              noOuterSpacing
            />
          </>
        ))}
      <GroupSection
        header={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.IncomingInvoice.AddSupplierPostalAddress
        )}
        description={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.IncomingInvoice.SupplierPostalAddressSubText
        )}
        className={cssExports.noBorder}
      >
        <Grid container direction="row" rowGap={1} columnGap={1}>
          <VerticalFormField<TextInputProps>
            Component={TextInput}
            {...connect("street")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress)}
            maxLength={100}
            noOuterSpacing
          />
          <VerticalFormField<TextInputProps>
            Component={TextInput}
            {...connect("street2")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StreetAddress2)}
            maxLength={100}
            noOuterSpacing
            optional
          />
          <Grid item container direction="row" columnGap={1} wrap="nowrap">
            <Grid item xs={6}>
              <VerticalFormField<TextInputProps>
                Component={TextInput}
                {...connect("zipCode")}
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PostalCode)}
                maxLength={12}
                noOuterSpacing
              />
            </Grid>
            <Grid item xs={6}>
              <VerticalFormField<TextInputProps>
                Component={TextInput}
                {...connect("city")}
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.City)}
                maxLength={100}
                noOuterSpacing
              />
            </Grid>
          </Grid>
          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("country")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Country)}
            items={CountryHelper.getCountrySelectionList()}
            noOuterSpacing
          />
        </Grid>
      </GroupSection>
    </Grid>
  );
};

export default InternationalPaymentFormStep;
